import React from 'react';
import classnames from 'classnames';
import { Button, DialogContent, Theme, Typography, useMediaQuery } from '@mui/material';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import { useTranslation } from 'react-i18next';
import { isHipaaLink } from 'config/productProfile';

import { noop } from 'utils';

import styles from './CheckedInDialog.module.scss';

export interface CheckedInDialogProps extends DialogProps {
  onConfirm: () => void;
}

export function CheckedInDialog({ onConfirm, ...rest }: CheckedInDialogProps) {
  const { t } = useTranslation('link');
  const isTablet = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  return (
    <Dialog
      {...rest}
      className={classnames(styles.dialog, {
        [styles.dialogTablet]: isTablet,
      })}
      onClose={noop}
    >
      <DialogContent>
        <Typography component='p' variant='h4'>
          <span>{t('checkedIn.youAreNow')}</span>
          <br />
          <strong>
            {t('checkedIn.checkedIn')} <span className={styles.greenCheck}>{'\u2714'}</span>
          </strong>
        </Typography>
        <Typography component='p' variant='body5'>
          {isHipaaLink ? t('checkedIn.providerNotified') : t('checkedIn.hostNotified')}
        </Typography>

        <Button variant='contained' onClick={onConfirm} className={styles.formButton}>
          {t('checkedIn.ok')}
        </Button>

        {isHipaaLink && (
          <Typography component='p' variant='body6'>
            {t('checkedIn.emergency911')}
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
}
